// extracted by mini-css-extract-plugin
export default {"priceContainer":"PriceInfo_priceContainer__MewaZ","buttonContainer":"PriceInfo_buttonContainer__cJZHU","productPrice":"PriceInfo_productPrice__ZlzIA"};